import { ABState } from 'mk2/containers/AB/AB.reducers';
import { cacheLast } from 'mk2/helpers/cache';
import { AppState } from 'mk2/reducers';
import { LoadingState } from 'mk2/reducers/loadingState';

const getABVariantCache = cacheLast(true);

export const getABVariant = (state: AppState, name: string): ABState => {
    return state.containers.global.ab[name] || getABVariantCache(() => {
        return {
            loadingState: LoadingState.INIT,
            variant: null,
        };
    }, name);
};
